// api/metricsApi.js
import BASE_URL from '../config' ;
const API_BASE_URL = BASE_URL;

class MetricsAPI {
  constructor() {
    this.baseURL = `${API_BASE_URL}/metrics`;
  }

  // Helper method to get auth headers - token only
  getAuthHeaders() {
    const token = localStorage.getItem('rental_management_token');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    };
  }

  // Helper method for API calls
  async apiCall(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      headers: this.getAuthHeaders(),
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`API call failed for ${endpoint}:`, error);
      throw error;
    }
  }

  // Get all dashboard metrics in one call
  async getAllDashboardMetrics() {
    return this.apiCall('/dashboard/');
  }

  // Get property metrics
  async getPropertyMetrics() {
    return this.apiCall('/property/');
  }

  // Get financial metrics
  async getFinancialMetrics() {
    return this.apiCall('/financial/');
  }

  // Get monthly revenue data
  async getMonthlyRevenue(months = 6) {
    return this.apiCall(`/monthly-revenue/?months=${months}`);
  }

  // Get turnover data
  async getTurnoverData(months = 6) {
    return this.apiCall(`/turnover/?months=${months}`);
  }

  // Get apartment performance
  async getApartmentPerformance() {
    return this.apiCall('/apartment-performance/');
  }
}

// Create and export a singleton instance
const metricsAPI = new MetricsAPI();
export default metricsAPI;

// Also export the class for custom instances if needed
export { MetricsAPI };

